import { useEffect, useState } from "react";

function SectionTabs({ scrollToSection }) {
  const [active, setActive] = useState("presentation");

  useEffect(() => {
    const sections = ["presentation", "rooms", "equipements"];

    const handleScroll = () => {
      let current = "presentation";

      sections.forEach((id) => {
        const el = document.getElementById(id);
        if (!el) return;

        const offsetTop = el.offsetTop - 120;

        if (window.scrollY >= offsetTop) {
          current = id;
        }
      });

      setActive(current);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const tabs = [
    { id: "presentation", label: "Présentation" },
    { id: "rooms", label: "Chambres" },
    { id: "equipements", label: "Équipements" },
  ];

  return (
    <div className="
  w-full
  mb-10
  border-b border-gray-200/70
  bg-white/60 backdrop-blur-sm
">

  <div className="flex justify-between w-full text-base font-medium">

    {tabs.map((tab) => (
      <div
        key={tab.id}
        onClick={() => {
          scrollToSection(tab.id);
          setActive(tab.id);
        }}
        className="
          flex-1 text-center cursor-pointer
          py-4
          relative
          text-gray-600 hover:text-black
          transition
        "
      >
        {tab.label}

        <span
          className={`
            absolute left-0 bottom-0 h-[2px]
            bg-[#3A9D23]
            transition-all duration-300 ease-out
            ${active === tab.id ? "w-full" : "w-0"}
          `}
        />
      </div>
    ))}

  </div>

</div>
  );
}

export default SectionTabs;